/* Hand-written React port of src/assets/icons/football.svg — a stroked ball,
   its pentagon/hexagon seams drawn full-size and clipped back to the circle.
   The .svg is the source of truth for the geometry: edit both together.
   Inlined rather than imported for the same reason as ScorelineIcon: no
   vite-plugin-svgr here, and the glyph has to inherit `currentColor`. */

import { useId } from 'react'

interface FootballIconProps {
  className?: string
}

export default function FootballIcon({ className }: FootballIconProps) {
  // The seams overshoot the ball and are clipped back to it, so every instance
  // needs its own clipPath id — a match timeline renders one of these per goal,
  // and duplicate ids would leave all but the first pointing at a foreign clip.
  const clipId = useId()
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      aria-label="Goal"
      focusable="false"
    >
      <defs>
        <clipPath id={clipId}>
          <circle cx="12" cy="12" r="9.5" />
        </clipPath>
      </defs>
      <circle cx="12" cy="12" r="9.5" />
      <g clipPath={`url(#${clipId})`}>
        <path d="M12.00 8.18 15.63 10.82 14.25 15.09 9.75 15.09 8.37 10.82Z" />
        <path d="M12.00 8.18L12.00 4.13" />
        <path d="M15.63 10.82L19.48 9.57" />
        <path d="M14.25 15.09L16.63 18.37" />
        <path d="M9.75 15.09L7.37 18.37" />
        <path d="M8.37 10.82L4.52 9.57" />
        <path d="M12.00 4.13 9.05 1.99 10.18 -1.48 13.82 -1.48 14.95 1.99Z" />
        <path d="M19.48 9.57 20.61 6.10 24.26 6.10 25.38 9.57 22.43 11.71Z" />
        <path d="M16.63 18.37 20.27 18.37 21.40 21.83 18.45 23.97 15.50 21.83Z" />
        <path d="M7.37 18.37 8.50 21.83 5.55 23.97 2.60 21.83 3.73 18.37Z" />
        <path d="M4.52 9.57 1.57 11.71 -1.38 9.57 -0.26 6.10 3.39 6.10Z" />
      </g>
    </svg>
  )
}
